import {
  backend_url,
  uninterceptedAxiosInstance,
  qs,
} from "../common/commonVariables";

export const updateWorkRequestStatus = async (ID, status, declinedReason) => {
  try {
    let params = {
      status,
      declinedReason,
    };
    const response = await uninterceptedAxiosInstance.put(
      backend_url + "work-requests/" + ID,
      { data: params },
      {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
        },
      }
    );

    let the_response = response;

    return the_response;
  } catch (err) {
    if (err.response) {
    } else if (err.request) {
    } else {
    }
  }
};
